<!-- @format -->

@if (openUniversityCart) {
  <div class="container sis-pt-md">
    @if (isSuomiFiPath) {
      <div class="sis-my-md">
        <sis-contextual-notification variant="light">
          <span tabindex="-1" #currentStepNameFocus>
            {{ "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.SUOMI_FI.LOGOUT_BUTTON_TEXT" | translate }}
          </span>
          <sis-button [link]="true" (clicked)="suomiFiLogout()">
            {{ "OPEN_UNIVERSITY.STUDIES_ACTIVATE_WIZARD.SUOMI_FI.LOGOUT_BUTTON" | translate }}
          </sis-button>
        </sis-contextual-notification>
      </div>
    }
    @if (currentStep === 0) {
      <app-open-university-studies-activate-wizard-step1
        [openUniversityCart]="openUniversityCart"
        [wizardProgressStepKeys]="wizardProgressStepKeys"
        [courseUnits]="courseUnits" />
    }
    @if (currentStep === 1) {
      <app-open-university-studies-activate-wizard-step2
        [openUniversityCart]="openUniversityCart"
        [wizardProgressStepKeys]="wizardProgressStepKeys"
        [isSuomiFiPath]="isSuomiFiPath"
        [suomiFiUserBasicDetails]="suomiFiUserBasicDetails"
        (goToLastStep)="goToLastStep($event)" />
    }
    @if (currentStep === 2 && openUniversityProducts.length > 0) {
      <app-open-university-studies-activate-wizard-step3
        [openUniversityCart]="openUniversityCart"
        [wizardProgressStepKeys]="wizardProgressStepKeys"
        [openUniversityProducts]="openUniversityProducts"
        [courseUnits]="courseUnits"
        [assessmentItemsData]="assessmentItemsData"
        [isSuomiFiPath]="isSuomiFiPath"
        [isStaffUser]="isStaffUser"
        (logoutFromSuomiFi)="suomiFiLogout()" />
    }
  </div>
}
@if (!openUniversityCart) {
  <app-open-university-studies-activate-error />
}
